import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Box, Avatar, Typography, IconButton, useMediaQuery } from '@mui/material';

import { IconPower } from '@tabler/icons-react';

import { getUserData } from '@store/user/selector';
import { logout } from '@utility/function/logout';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

const roles = localStorage.getItem('roles');
const isImpersonation = localStorage.getItem('isImpersonation');

export const Profile = () => {
  const { t } = useTranslation();

  const customizer = useSelector((state) => state.customizer);
  const userData = useSelector(getUserData);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const hideMenu = lgUp ? customizer.isCollapse && !customizer.isSidebarHover : '';

  const slitName = (name) => {
    const a = String(name?.trim()).split(' ');
    if (a.length > 10) {
      const n = a.slice(Math.max(a.length - a.length, -1), 10);
      return n.join(' ') + '...';
    }

    return name;
  };

  return (
    !hideMenu && (
      <Box
        display={'flex'}
        alignItems="center"
        gap={1}
        sx={{ m: 3, p: 2, bgcolor: `${'secondary.light'}` }}
      >
        <Avatar
          sizes="32px"
          alt={userData?.name}
          src={
            isImpersonation || roles === 'BTC'
              ? userData?.mstEvent?.linkIcon
                ? userData?.mstEvent?.linkIcon
                : userData?.mstEvent?.logo
              : userData.avatar
          }
        />
        <Box>
          <Typography variant="body2" color="textPrimary">
            {slitName(userData?.name)}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {userData?.roles}
          </Typography>
        </Box>
        <Box sx={{ ml: 'auto' }}>
          <Tooltip
            placement="top"
            color="#fff"
            overlayInnerStyle={{ color: '#2A3547' }}
            title={t('CORE:logout')}
          >
            <IconButton
              color="primary"
              component={Link}
              onClick={logout}
              aria-label="logout"
              size="small"
            >
              <IconPower size="20" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    )
  );
};
